export const metresToKilometres = (number: number) => {
  return number / 1000
}

export const kilometresToMetres = (number: number) => {
  return number * 1000
}
